export const buildNotebookErrorMessages = ({
  nameMin,
  nameMax,
  descriptionMin,
  descriptionMax,
  summaryMin,
  summaryMax,
}: {
  nameMin: number;
  nameMax: number;
  descriptionMin: number;
  descriptionMax: number;
  summaryMin: number;
  summaryMax: number;
}) => ({
  nameMinError: `Notebook name must be at least ${nameMin} characters long`,
  nameMaxError: `Notebook name must be at most ${nameMax} characters long`,
  notebookDescriptionMinError: `Notebook description must be at least ${descriptionMin} characters long`,
  notebookDescriptionMaxError: `Notebook description must be at most ${descriptionMax} characters long`,
  notebookSummaryMinError: `Notebook summary must be at least ${summaryMin} characters long`,
  notebookSummaryMaxError: `Notebook summary must be at most ${summaryMax} characters long`,
  gradeError: 'Select a grade level.',
  unitError: 'Select a unit.',
  notebookTemplateError: 'Select a framework.',
});
